// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

const propDataType = objectOf({
  is_enabled: boolean,
  is_default: maybe(boolean),
});

export const isAppSettingsInternalUserGroupsInternalUserGroupUpsertResult = objectOf({
  id: string,
  name: string,
  property_data: objectOf({
    content_test: propDataType,
    seed_group: propDataType,
    user_event_log: propDataType,
    sdk_internal_message_log: propDataType,
  }),
  territory_ids: arrayOf(string),
});
